import { render, staticRenderFns } from "./GenericUpsell.vue?vue&type=template&id=5c4f8b0b&scoped=true&"
import script from "./GenericUpsell.vue?vue&type=script&lang=ts&"
export * from "./GenericUpsell.vue?vue&type=script&lang=ts&"
import style0 from "./GenericUpsell.vue?vue&type=style&index=0&id=5c4f8b0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f8b0b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,ClientOnlyPrice: require('/opt/build/repo/apps/shop/components/ClientOnlyPrice.vue').default})
